import { useState } from 'react'
import { STATICS } from 'statics'
import { InvoiceCard } from '../invoice-card'
import './style.scss'

export function InvoiceCardList({ items = [], itemsPerPage = 1 }) {
  const [itemsToShow, setItemsToShow] = useState(itemsPerPage)

  function getInvoicesToShow() {
    return items.slice(0, itemsToShow)
  }

  function handleSeeMoreClick() {
    setItemsToShow(prev => prev + itemsPerPage)
  }

  function renderInvoice(slip) {
    const { id, value, tags, isPaymentRecurring, expirationDate } = slip

    return (
      <InvoiceCard
        key={id}
        id={id}
        dueDate={expirationDate}
        isPaymentRecurring={isPaymentRecurring}
        tags={tags}
        value={value}
      />
    )
  }

  function renderInvoices() {
    const invoicesToShow = getInvoicesToShow()
    return invoicesToShow.map(renderInvoice)
  }

  function renderSeeMoreButton() {
    const hasMoreInvoicesToShow = items.length > itemsToShow

    if (!hasMoreInvoicesToShow) return null

    return (
      <button className='see-more-button' type='button' onClick={handleSeeMoreClick}>
        Ver mais <STATICS.ARROW_DOWN_BLACK />
      </button>
    )
  }

  function renderContent() {
    const hasInvoices = items.length

    if (!hasInvoices) return null

    return (
      <div className='container-invoices'>
        {renderInvoices()}
        {renderSeeMoreButton()}
      </div>
    )
  }

  return renderContent()
}
